import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MypageTextField from "../../../ui/MypageTextField";
import MypageNameTextField from "../../../ui/MypageNameTextField";
import MypagePhoneNumTextField from "../../../ui/MypagePhoneNumTextField";
import MypageSelect from "../../../ui/MypageSelect";
import MypageRadioField from "../../../ui/MypageRadioField";
import MypagePostcodeTextField from "../../../ui/MypagePostcodeTextField";
import BirthdayTextField from "../../../ui/MypageBirthdayTextField";
import Completion from "../common/Completion";
import Header from "../../../layout/mypage/Header";
import Footer from "../../../layout/mypage/Footer";
import ScreenColorSetting, {
  getDefaultScreenColor,
} from "../../../layout/mypage/ScreenColorSetting";
import {
  validateEmailAddress,
  validateDifferentVal,
  validateConfirm,
  validateRequired,
  validateNumber,
} from "../../../../utils/validate";
import { postAdmission } from "../../../../services/apiStudent";
import { MYPAGE_HTML_TITLE } from "../../../../utils/config";
import { getDefaultCalendar } from "../../../../utils/calcAge";

// 入学申込
const Admission = () => {
  const navigate = useNavigate();
  // 同意したかどうかのフラグ
  const [isConsent, setConsent] = useState(false);
  // 確認画面かどうかのフラグ
  const [isConfirmation, setIsConfirmation] = useState(false);
  // 申込完了フラグ
  const [compFlg, setCompFlg] = useState(false);
  // 画面背景色 color-standard or color-black or color-blue
  const [screenColor, setScreenColor] = useState(getDefaultScreenColor());
  // 入力チェック用
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  // 参加選択肢
  const isAttendOptions = [
    { value: "出席", text: "出席", defaultChecked: true },
    { value: "欠席", text: "欠席" },
  ];
  const [selectedIsAttend, setSelectedIsAttend] = useState(true);

  // 入学説明会キャンセル待ち選択肢
  const isOnWaitingListOptions = [
    { value: "はい", text: "はい", defaultChecked: true },
    { value: "いいえ", text: "いいえ" },
  ];
  const [selectedIsOnWaitingList, setSelectedIsOnWaitingList] = useState(true);

  // 同意するチェック
  const ConsentCheck = (e) => {
    setConsent(e.target.checked);
  };

  // 送信するボタン
  const onSubmit = async (data) => {
    if (isConfirmation) {
      const json = await postAdmission(data);
      if (json?.result) {
        setCompFlg(true);
        scrollTop();
      }
    } else {
      setIsConfirmation(true);
      scrollTop();
    }
  };

  // 入力画面へ戻る
  const handleBackConfirmation = () => {
    setIsConfirmation(false);
    scrollTop();
  };

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  useEffect(() => {
    (function () {
      // 既にログイン済みの場合はマイページ/管理画面トップへ
      if (localStorage.userData) {
        let userdata = JSON.parse(localStorage.userData);
        if (userdata.is_admin) {
          navigate("/admin/top", { replace: true });
        } else {
          navigate("/mypage/top", { replace: true });
        }
      }
      document.title = `入学申し込み | ${MYPAGE_HTML_TITLE}`;
      scrollTop();
      setValue("pref", "東京都");
      setValue("birthday", getDefaultCalendar());
    })();
  }, []);

  return (
    <>
      <ScreenColorSetting screenColor={screenColor} />
      <div className="mypage-site">
        <div className="mypage">
          <Header
            setScreenColor={setScreenColor}
            screenColor={screenColor}
            isLogin={false}
          />
          {compFlg ? (
            <Completion
              title="渋谷ハチコウ大学 入学申し込み完了"
              explanation={
                "入学のお申し込みが完了いたしました。" +
                "\r\n\r\n" +
                "入学申込受付メールが送られてこない場合、メールアドレスが間違っている場合があるため、渋谷ハチコウ大学事務局（03-6451-1417）に電話してください。"
              }
              link={process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN + "/"}
              btntext="シブカツトップへ戻る"
              isLoggedIn={false}
            />
          ) : (
            <main className="l-main">
              <div className="container">
                <div className="col-lg-10 offset-lg-1">
                  <div className="p-login-con">
                    <h1 className="p-heading01">
                      {isConfirmation
                        ? "渋谷ハチコウ大学 入学申し込み内容確認"
                        : "渋谷ハチコウ大学 入学申し込み"}
                    </h1>
                    <form
                      className="p-login-form"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <div className="p-login-con__form p-admission__form">
                        <MypageNameTextField
                          name="name"
                          subname={["name_l", "name_f"]}
                          label="氏名"
                          subLabel={["姓", "名"]}
                          maxLength={[14, 14]}
                          setValue={setValue}
                          register={register}
                          errors={errors}
                          watch={watch}
                          required={true}
                          isStatic={isConfirmation}
                          glue="　"
                        />
                        <MypageNameTextField
                          name="name_kana"
                          subname={["name_kana_l", "name_kana_f"]}
                          label="フリガナ"
                          subLabel={["セイ", "メイ"]}
                          maxLength={[14, 14]}
                          setValue={setValue}
                          register={register}
                          errors={errors}
                          watch={watch}
                          required={true}
                          isStatic={isConfirmation}
                          glue="　"
                        />
                        <MypagePostcodeTextField
                          register={register}
                          errors={errors}
                          watch={watch}
                          setValue={setValue}
                          addressField="street_name1"
                          required={true}
                          isStatic={isConfirmation}
                        />
                        <MypageTextField
                          name="pref"
                          label="都道府県"
                          register={register}
                          errors={errors}
                          watch={watch}
                          isStatic={true}
                        />
                        <MypageTextField
                          name="street_name1"
                          label="町名"
                          maxLength={30}
                          register={register}
                          errors={errors}
                          watch={watch}
                          required={true}
                          isStatic={isConfirmation}
                        />
                        <MypageTextField
                          name="street_name2"
                          label="丁名"
                          maxLength={30}
                          register={register}
                          validation={validateNumber()}
                          errors={errors}
                          watch={watch}
                          isStatic={isConfirmation}
                        />
                        <MypageTextField
                          name="address"
                          label="番地・号"
                          maxLength={30}
                          register={register}
                          errors={errors}
                          watch={watch}
                          required={true}
                          isStatic={isConfirmation}
                        />
                        <MypageTextField
                          name="street_name3"
                          label="方書き"
                          maxLength={60}
                          register={register}
                          errors={errors}
                          watch={watch}
                          isStatic={isConfirmation}
                        />
                        <BirthdayTextField
                          register={register}
                          setValue={setValue}
                          errors={errors}
                          required={true}
                          watch={watch}
                          isStatic={isConfirmation}
                        />
                        <MypageSelect
                          name="gender"
                          label="性別"
                          register={register}
                          errors={errors}
                          isStatic={isConfirmation}
                          options={[
                            { value: "男", text: "男" },
                            { value: "女", text: "女" },
                          ]}
                          watch={watch}
                          required={true}
                          isSetdefalut={true}
                        />
                        <MypagePhoneNumTextField
                          name="phone1"
                          label="電話番号1"
                          setValue={setValue}
                          register={register}
                          validation={{
                            ...validateDifferentVal(
                              "phone1",
                              "phone2",
                              "電話番号",
                            ),
                          }}
                          errors={errors}
                          watch={watch}
                          required={true}
                          isStatic={isConfirmation}
                        />
                        <MypageTextField
                          name="mail1"
                          label="メールアドレス1"
                          maxLength={100}
                          register={register}
                          validation={{
                            ...validateEmailAddress(),
                            ...validateDifferentVal(
                              "mail1",
                              "mail2",
                              "メールアドレス",
                            ),
                          }}
                          errors={errors}
                          watch={watch}
                          required={true}
                          isStatic={isConfirmation}
                        />
                        <div className={isConfirmation ? "d-none" : ""}>
                          <MypageTextField
                            name="mail1_confirm"
                            label="(確認用)"
                            subLabel={true}
                            maxLength={100}
                            register={register}
                            validation={{
                              ...validateEmailAddress(),
                              ...validateConfirm(
                                "mail1",
                                "mail1_confirm",
                                "メールアドレス1",
                              ),
                            }}
                            errors={errors}
                            watch={watch}
                            isStatic={isConfirmation}
                          />
                        </div>
                        <p className={`mb-5 ${isConfirmation ? "d-none" : ""}`}>
                          入学申込受付メールが送られてこない場合、メールアドレスが間違っている場合があるため、
                          <strong>
                            渋谷ハチコウ大学事務局（03-6451-1417）
                          </strong>
                          に電話してください。
                        </p>
                        <MypagePhoneNumTextField
                          name="phone2"
                          label="電話番号2"
                          setValue={setValue}
                          register={register}
                          validation={{
                            ...validateDifferentVal(
                              "phone1",
                              "phone2",
                              "電話番号",
                            ),
                          }}
                          errors={errors}
                          watch={watch}
                          isStatic={isConfirmation}
                        />
                        <MypageTextField
                          name="mail2"
                          label="メールアドレス2"
                          maxLength={100}
                          register={register}
                          validation={{
                            ...validateEmailAddress(),
                            ...validateDifferentVal(
                              "mail1",
                              "mail2",
                              "メールアドレス",
                            ),
                          }}
                          errors={errors}
                          watch={watch}
                          isStatic={isConfirmation}
                        />
                        <div className={isConfirmation ? "d-none" : ""}>
                          <MypageTextField
                            name="mail2_confirm"
                            label="(確認用)"
                            subLabel={true}
                            maxLength={100}
                            register={register}
                            validation={{
                              ...validateEmailAddress(),
                              ...validateConfirm(
                                "mail2",
                                "mail2_confirm",
                                "メールアドレス2",
                              ),
                            }}
                            errors={errors}
                            watch={watch}
                          />
                        </div>
                        <p
                          className={`mt-2 mb-3 ${
                            isConfirmation ? "d-none" : ""
                          }`}
                        >
                          緊急連絡先の記入は必須ではありませんが、なるべくご記入ください。
                        </p>
                        <MypageTextField
                          name="emergency_contacts_name"
                          label="緊急連絡先(氏名)"
                          maxLength={30}
                          register={register}
                          errors={errors}
                          watch={watch}
                          isStatic={isConfirmation}
                        />
                        <MypageTextField
                          name="emergency_contacts_emereletion"
                          label="緊急連絡先(続柄)"
                          maxLength={30}
                          register={register}
                          errors={errors}
                          watch={watch}
                          isStatic={isConfirmation}
                        />
                        <MypagePhoneNumTextField
                          name="emergency_contacts_phone"
                          label="緊急連絡先(電話番号)"
                          setValue={setValue}
                          register={register}
                          errors={errors}
                          watch={watch}
                          isStatic={isConfirmation}
                        />
                        {/* 途中入学の時期はコメントアウト（ここから）*/}
                        <h2 className="p-course-page__heading mt-5">
                          入学説明会のご案内
                        </h2>
                        <div
                          className={`mt-2 mb-5 ${
                            isConfirmation ? "d-none" : ""
                          }`}
                        >
                          <p>日時：10月26日（月）13時30分</p>
                          <p>
                            場所：渋谷生涯活躍ネットワークシブカツ　イベントスペース（渋谷区渋谷2-21-1渋谷ヒカリエ8階）
                          </p>
                          <p>
                            説明会は20～30分程度を予定しており、その後に渋谷区歯科衛生士による特別講座「～今からできる～口からはじめる「健(けん)口(こう)投資」」も実施いたします（所要時間：1時間程度）。
                          </p>
                          <p className="mb-4">
                            なお、ご入学の皆様には入学説明動画を共有させていただく予定ですが、動画内に特別講座は含まれません。講座参加をご希望の方はぜひ入学説明会にご出席ください。
                          </p>
                          <p>出欠のご回答をお願いいたします。</p>
                          <p>※定員先着50名</p>
                          <p>
                            ※出席をご選択後、ご都合が悪くなった場合は、必ず事務局までご連絡ください。
                          </p>
                        </div>
                        <MypageRadioField
                          name="is_attendance"
                          label="説明会出欠"
                          elements={isAttendOptions}
                          register={register}
                          validation={{
                            ...validateRequired(),
                          }}
                          errors={errors}
                          watch={watch}
                          required={true}
                          isStatic={isConfirmation}
                          selectedValue={selectedIsAttend}
                          setSelectedValue={setSelectedIsAttend}
                        />
                        {/* 定員に達したら解禁 
                        <div
                          className={`mt-2 mb-5 ${
                            isConfirmation ? "d-none" : ""
                          }`}
                        >
                          <p className="mb-4">
                            申込数が定員に達しました。キャンセル等によりお席をご用意できるようになった場合に事務局からの案内を希望しますか。
                          </p>
                        </div>
                        <MypageRadioField
                          name="is_on_waiting_list"
                          label="案内希望"
                          elements={isOnWaitingListOptions}
                          register={register}
                          validation={{
                            ...validateRequired(),
                          }}
                          errors={errors}
                          watch={watch}
                          required={true}
                          isStatic={isConfirmation}
                          selectedValue={selectedIsOnWaitingList}
                          setSelectedValue={setSelectedIsOnWaitingList}
                        />*/}
                        {/* 途中入学の時期はコメントアウト（ここまで） */}
                        <h2 className="p-course-page__heading mt-5">
                          注意事項
                        </h2>
                        <ul className="p-list">
                          <li className="p-list__item">
                            個人情報の取扱い
                            <p>【個人情報の利用目的】 </p>
                            <p>
                              収集した個人情報は、受講料や受講票の発送、必要事項の連絡等のため、渋谷ハチコウ大学が開催する講座に関する業務において利用いたします。
                            </p>
                            <p>
                              本人確認のため住民基本台帳を確認させていただきます。
                            </p>
                            <p>【個人情報の第三者提供】</p>
                            <p>
                              収集した個人情報は、次に掲げる場合を除き、個人情報を第三者に提供することはいたしません。
                            </p>
                            <p>
                              渋谷ハチコウ大学講座主催者への情報提供（講座の受講に対して、主催者が受講者へ連絡を行うため。）
                            </p>
                          </li>
                          <li className="p-list__item">
                            大学施設
                            <p>
                              大学施設について、要望は一切できません。決められたルール内で御利用ください。
                            </p>
                          </li>
                          <li className="p-list__item">
                            大学連携講座の申し込みキャンセル
                            <p>
                              大学連携講座については、申込期間終了後のキャンセルは受講料のお支払いが必要になり、返金もできかねますのでご注意ください。
                            </p>
                          </li>
                        </ul>
                        <div className={isConfirmation ? "d-none" : ""}>
                          <p className="text-center">
                            <label>
                              <input
                                type="checkbox"
                                onChange={(e) => ConsentCheck(e)}
                              />
                              上記の内容に同意する
                            </label>
                          </p>
                        </div>
                        <div className="p-login-form__btnbox">
                          {isConfirmation ? (
                            <div className="p-login-form__returnbtn">
                              <input
                                className="p-login-form__link"
                                type="button"
                                value="変更ページへ戻る"
                                onClick={() => handleBackConfirmation()}
                              />
                            </div>
                          ) : (
                            <></>
                          )}
                          <div className="p-login-form__send">
                            <input
                              className="p-login-form__link"
                              type="submit"
                              value={isConfirmation ? "送信する" : "確認"}
                              disabled={!isConsent}
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </main>
          )}
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Admission;
